export default class Search {

    constructor() {
        this.search();
    }

    search() {
        const search = document.querySelector('#frmZoeken');

        if (search) {
            if (window.innerWidth < 768) {
                const expand = search.querySelector('.expand');
                let submitted = false;

                expand.setAttribute('data-height', expand.offsetHeight);
                expand.style.height = 0;

                search.querySelector('form').addEventListener('submit', function(ev) {
                    if (submitted === false) {
                        ev.preventDefault();
                        submitted = true;

                        expand.style.height = expand.getAttribute('data-height') + "px";
                    }
                });
            }

            const propertysoort = search.querySelector('#propertysoort');
            const prijsMin = search.querySelector('#prijs_min');
            const prijsMax = search.querySelector('#prijs_max');

            const dataPrijsKoopMin = JSON.parse(prijsMin.getAttribute('data-koop-min'));
            const dataPrijsKoopMax = JSON.parse(prijsMax.getAttribute('data-koop-max'));
            const dataPrijsHuurMin = JSON.parse(prijsMin.getAttribute('data-huur-min'));
            const dataPrijsHuurMax = JSON.parse(prijsMax.getAttribute('data-huur-max'));

            let koopOptionsMin = '';
            let koopOptionsMax = '';
            let huurOptionsMin = '';
            let huurOptionsMax = '';

            for (const [key, val] of Object.entries(dataPrijsKoopMin)) {
                koopOptionsMin += '<option value="' + key + '">' + val + '</option>';
            }
            for (const [key, val] of Object.entries(dataPrijsKoopMax)) {
                koopOptionsMax += '<option value="' + key + '">' + val + '</option>';
            }
            for (const [key, val] of Object.entries(dataPrijsHuurMin)) {
                huurOptionsMin += '<option value="' + key + '">' + val + '</option>';
            }
            for (const [key, val] of Object.entries(dataPrijsHuurMax)) {
                huurOptionsMax += '<option value="' + key + '">' + val + '</option>';
            }

            propertysoort.addEventListener('change', function() {
                if (propertysoort.value == 'huurwoningen') {
                    prijsMin.innerHTML = huurOptionsMin;
                    prijsMax.innerHTML = huurOptionsMax;
                } else {
                    prijsMin.innerHTML = koopOptionsMin;
                    prijsMax.innerHTML = koopOptionsMax;
                }
            });
        }
    }
}
